import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './common/api-services';
import { TranslocoService } from '@jsverse/transloco';
import { catchError, of, take, timeout } from 'rxjs';
import { LanguageService } from './common/app-services/language.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
    /**
     * Constructor
     */
    constructor(
        private authService: AuthService,
        private translocoService: TranslocoService,
        private languageService: LanguageService
    ) { }

    ngOnInit(): void {
        // S'abonner aux changements de langue
        this.languageService.langChanged$.subscribe(lang => {
            if (this.translocoService.getActiveLang() !== lang) {
                this.translocoService.setActiveLang(lang);
            }
        });
    }
}
